import {
  breakpointSizes,
  getBreakpointUp,
  getFontCss,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import Box from 'src/components/Box/Box'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import { NavAwayProps } from 'src/components/NavAwayBox/NavAwayBox'
import SvgArrowForward from 'src/components/Svgs/SvgArrowForward'
import SvgClose from 'src/components/Svgs/SvgClose'
import SvgExpand from 'src/components/Svgs/SvgExpand'
import { css } from 'styled-components'

interface PermanentPromotionBoxProps {
  className?: string
  id?: string
  imageSrc: string
  title: React.ReactNode
  subtitle: React.ReactNode
  navAway?: NavAwayProps
  dismissPromo?: () => void
  usePlus?: boolean
  onClick?: () => void
  hasRedNotificationDot?: boolean
  isSmallIcon?: boolean
  isMediumIcon?: boolean
  orgPromoBox?: boolean
  createExpPromoBox?: boolean
}

const PermanentPromotionBox: React.FC<
  React.PropsWithChildren<PermanentPromotionBoxProps>
> = (props): React.ReactElement => {
  const handleOnClick = (): void => {
    if (props?.onClick !== undefined) {
      props.onClick()
    }
  }

  return (
    <Box
      className={props.className}
      css={css`
        display: flex;
        overflow: hidden;
        position: relative;
      `}
    >
      {props.hasRedNotificationDot && (
        <span
          css={css`
            height: 12px;
            width: 12px;
            background-color: ${styleConstants.colors.red};
            border-radius: 50%;
            position: absolute;
            top: 20px;
            left: 20px;
          `}
        ></span>
      )}
      {props.dismissPromo !== undefined && (
        <SvgClose
          id={props.id ? props.id : 'svgClose'}
          css={css`
            position: absolute;
            top: 10px;
            right: 10px;
            cursor: pointer;
          `}
          onClick={props.dismissPromo}
        />
      )}
      <img
        css={css`
          ${props.isSmallIcon
            ? `width: 54px;
          height: 54px;`
            : props.isMediumIcon
              ? `width: 56px;
      height: 60px;`
              : `width: 110px;
        height: 100px;`}

          ${getBreakpointUp(breakpointSizes.SM)(css`
            flex-shrink: 0;
          `)}
        `}
        src={props.imageSrc}
        alt={''}
      />
      <div
        css={css`
          ${props.orgPromoBox || props.createExpPromoBox
            ? `margin-left: 23px;
        margin-right: 100px;`
            : `margin-left: 40px;`}
          display: flex;
          flex-direction: column;
          overflow: hidden;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              20,
              styleConstants.colors.black,
              styleConstants.fontFamilies.medium,
            )}
            margin-bottom: 12px;
          `}
        >
          {props.title}
        </span>
        <span
          css={css`
            ${getFontCss(
              14,
              styleConstants.colors.black,
              styleConstants.fontFamilies.regular,
            )}
            ${props.navAway ? `margin-bottom: 24px;` : ``}
          `}
        >
          {props.subtitle}
        </span>
        {props.navAway && (
          <HoverableLink
            id={props.navAway.id}
            onClick={(): void => {
              handleOnClick()
            }}
            css={css`
              display: flex;
              align-items: center;
            `}
            to={props.navAway.to}
            {...(props.navAway.ariaLabelSource !== undefined
              ? { ariaLabelSource: props.navAway.ariaLabelSource }
              : { ariaLabel: props.navAway.ariaLabel })}
          >
            {props.navAway.label}
            {props.usePlus && (
              <SvgExpand
                css={css`
                  transform: scale(calc(14 / 24));
                `}
              />
            )}
            {!props.usePlus && (
              <SvgArrowForward
                css={css`
                  transform: scale(calc(14 / 24));
                `}
              />
            )}
          </HoverableLink>
        )}
      </div>
    </Box>
  )
}

export default PermanentPromotionBox
